import {createDualReporter} from './createDualReporter';
import {createAnalyticsContext} from './createAnalyticsContext';
import {createUseAnalytics} from './createUseAnalytics';
import {createAnalyticsProvider} from './createAnalyticsProvider';
import {createAnalyticsConsumer} from './createAnalyticsConsumer';
import {createAnalyticsReporter} from './createAnalyticsReporter';
import {AnalyticsConfig} from '../core/types';

export function createAnalytics<T extends string>(config: AnalyticsConfig) {
  const analyticsReporter = createAnalyticsReporter<T>(config);
  const analyticsContext = createAnalyticsContext<T>(analyticsReporter);
  const useAnalytics = createUseAnalytics(analyticsContext);
  const AnalyticsProvider = createAnalyticsProvider(
    analyticsReporter,
    analyticsContext,
  );
  const AnalyticsConsumer = createAnalyticsConsumer(analyticsContext);
  return {
    analyticsContext,
    useAnalytics,
    AnalyticsProvider,
    AnalyticsConsumer,
  };
}

export function createDualAnalytics<T extends string>(
  aelConfig: AnalyticsConfig,
  deprecatedConfig: AnalyticsConfig,
  experimentsList: Array<string>,
  filterExperiments: (
    eventName: string,
    experimentName: unknown,
    experimentsList: Array<string>,
  ) => boolean,
) {
  const dualReporter = createDualReporter<T>(
    aelConfig,
    deprecatedConfig,
    experimentsList,
    filterExperiments,
  );
  const dualContext = createAnalyticsContext<T>(dualReporter);
  const useDualAnalytics = createUseAnalytics(dualContext);
  const DualAnalyticsProvider = createAnalyticsProvider(
    dualReporter,
    dualContext,
  );
  const DualAnalyticsConsumer = createAnalyticsConsumer(dualContext);
  return {
    dualContext,
    useDualAnalytics,
    DualAnalyticsProvider,
    DualAnalyticsConsumer,
  };
}
